import { Button, Confirm, useTranslate } from "react-admin";
import React, { Fragment, useState } from "react";

import { API_URL } from "../../config";
import PrintIcon from "@material-ui/icons/Print";
import { get } from "lodash";
import { getToken } from "ra-friendsofbabba";
import { stringify } from "query-string";

const PrintButton = ({
  record,
  disabled = false,
  pristine = true,
  sourceId = "id",
  variant = "text",
  label = "ra.action.print",
  resource,
  action = "print",
  queryString,
  confirm = false,
}) => {
  const recordId = get(record, sourceId, null);
  const url = `${API_URL}/${resource}/${action}?token=${getToken()}&${stringify(
    typeof queryString === "function" ? queryString(record) : { id: recordId }
  )}`;
  const translate = useTranslate();
  const [open, setOpen] = useState(false);
  if (recordId === null) {
    return null;
  }

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleConfirm = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setOpen(false);
    window.open(url, "_blank");
  };
  return (
    <Fragment>
      <Button
        color="primary"
        disabled={disabled}
        variant={variant}
        label={translate(label)}
        onClick={!pristine || confirm ? handleOpen : handleConfirm}
      >
        <PrintIcon />
      </Button>
      <Confirm
        isOpen={open}
        title={`ra.title.warning_${!pristine ? "pristine" : "confirm"}`}
        content={`ra.message.warning_${!pristine ? "pristine" : "confirm"}`}
        onConfirm={handleConfirm}
        onClose={handleClose}
      />
    </Fragment>
  );
};
export default PrintButton;
